import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { getAllUsers } from "store/actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import shareContact from "../../../assets/img/theme/SavedContract.png";

import HomeLeftCol from "./HomeLeftCol";
import HomeCenterCol from "./HomeCenterCol";
import HomeRightCol from "./HomeRightCol";
import HomeUserCards from "./HomeUserCards";
import HomeModals from "./HomeModals";

const allUrls = [
  { id: 1,  copyLink: "https://www.youtube.com/watch?v=mQyGcaUsJmI",  link: "https://youtu.be/mQyGcaUsJmI" },
  { id: 2, copyLink: "https://www.youtube.com/watch?v=BpN34V0tvWE",  link: "https://youtu.be/BpN34V0tvWE" },
  { id: 3, copyLink: "https://www.youtube.com/watch?v=oMLOUpR9K6M",  link: "https://youtu.be/oMLOUpR9K6M" },
  { id: 4, copyLink: "https://www.youtube.com/watch?v=GAdKqBHtrc8",  link: "https://youtu.be/GAdKqBHtrc8" },
  { id: 5, copyLink: "https://www.youtube.com/watch?v=_6LMG96t3p4",  link: "https://youtu.be/_6LMG96t3p4" },
  { id: 6, copyLink: "https://www.youtube.com/watch?v=eTUUlO7C8W8",  link: "https://youtu.be/eTUUlO7C8W8" },
  { id: 7, copyLink: "https://www.youtube.com/watch?v=vbEMjyeBHnE",  link: "https://youtu.be/vbEMjyeBHnE" },
  { id: 8, copyLink: "https://www.youtube.com/watch?v=Q6s2huKBiro",  link: "https://youtu.be/Q6s2huKBiro" },
  { id: 9, copyLink: "https://www.youtube.com/watch?v=sRWdxm31B28",  link: "https://youtu.be/sRWdxm31B28" },
];

function Home() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isMountedRef = useRef(true);
  const { allUsers } = useSelector((state) => state.users);

  // Video carousel
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [videoId, setVideoId] = useState("");

  // Install prompt
  const [isInstalled, setIsInstalled] = useState(false);
  const [active, setActive] = useState(0);
  const [appleModal, setAppleModal] = useState(false);
  const [androidModal, setAndroidModal] = useState(false);

  // Register notice
  const [registerNotice, setRegisterNotice] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);

  // Image preview
  const [imgModal, setImgModal] = useState(false);
  const [showModalImg, setShowModalImg] = useState("");

  // Various modals
  const [adModalOpen, setAdModalOpen] = useState(false);
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isShow2, setIsShow2] = useState(false);
  const [modal, setModal] = useState(false);
  const [coinInfoOpen, setCoinInfoOpen] = useState(false);
  const [membershipModal, setMembershipModal] = useState(false);
  const [fhpCoinModal, setFhpCoinModal] = useState(false);
  const [schoolDiscountModal, setSchoolDiscountModal] = useState(false);
  const [vendorDiscountModal, setVendorDiscountModal] = useState(false);
  const [gameDayStayModal, setGameDayStayModal] = useState(false);
  const [tokenPoolModal, setTokenPoolModal] = useState(false);
  const [fhpCoinTokenModal, setFhpCoinTokenModal] = useState(false);
  const [fhpCoinVideoModal, setFhpCoinVideoModal] = useState(false);
  const [fanSkillContest, setFanSkillContest] = useState(false);
  const [sportsMemeModal, setSportsMemeModal] = useState(false);

  // Toggles
  const toggleCoinInfo = () => setCoinInfoOpen((v) => !v);
  const toggleSportsMeme = () => setSportsMemeModal((v) => !v);
  const toggleFanSkillContest = () => setFanSkillContest((v) => !v);
  const toggleFhpCoinVideo = () => setFhpCoinVideoModal((v) => !v);
  const toggleFhpCoinToken = () => setFhpCoinTokenModal((v) => !v);
  const toggleTokenPool = () => setTokenPoolModal((v) => !v);
  const toggleGameDayStay = () => setGameDayStayModal((v) => !v);
  const toggleMemberShipModal = () => setMembershipModal((v) => !v);
  const toggleSchoolDiscount = () => setSchoolDiscountModal((v) => !v);
  const toggleVendorDiscount = () => setVendorDiscountModal((v) => !v);
  const toggleFhpCoinModal = () => setFhpCoinModal((v) => !v);
  const disclaimerToggle = () => setIsDisclaimerOpen((v) => !v);
  const toggleAdModal = () => setAdModalOpen((v) => !v);
  const toggleImgModal = () => setImgModal((v) => !v);
  const toggle = () => setIsShow((v) => !v);
  const toggle2 = () => setIsShow2((v) => !v);
  const Modaltoggle = () => setModal((v) => !v);
  const appleToggle = () => { setActive(0); setAppleModal((v) => !v); };
  const androidToggle = () => { setActive(0); setAndroidModal((v) => !v); };
  const registerNoticeToggle = () => setRegisterModal((v) => !v);

  // Derived video data
  const currentVideoIndexValidated = isNaN(currentVideoIndex) ? 0 : currentVideoIndex;
  const usersWithQrUrl = allUsers?.filter(
    (user) =>
      user?.Qr_Url && (user.first_name || user.t_name || user.athleteID),
  );
  const currentVideo = usersWithQrUrl[currentVideoIndexValidated];
  const videoIdMatch = currentVideo?.Qr_Url?.split("v=")[1].split("&")[0];

  const handleVideoStateChange = (event) => {
    if (event.data === 1 /* PLAYING */) {
      const intervalId = setInterval(() => {
        if (currentVideoIndex <= usersWithQrUrl.length - 1) {
          if (isMountedRef.current) {
            setCurrentVideoIndex(currentVideoIndex + 1);
            clearInterval(intervalId);
          } else {
            clearInterval(intervalId);
          }
        } else {
          setCurrentVideoIndex(0);
        }
      }, 10000);
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href =
      "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/FHP%20Coins%20Whitepaper%20New.pdf?alt=media&token=dec346e5-b7a9-407f-9063-f2900662f090";
    link.download = "FHP-Whitepaper";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadEcosystemPdf = () => {
    const pdfEcosystem =
      "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/FHPcoin_Proposal_new.pdf?alt=media&token=10545bef-26bf-4da5-8ef4-46ae318ce813";
    window.open(pdfEcosystem, "_blank");
    const link = document.createElement("a");
    link.download = "School-Ecosystem";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const checkIsInstalled = () => {
    window.addEventListener("appinstalled", () => setIsInstalled(true));
  };

  useEffect(() => {
    if (currentVideoIndex <= usersWithQrUrl.length - 1) {
      setVideoId(videoIdMatch);
    } else {
      setVideoId("");
    }
  }, [currentVideoIndex, usersWithQrUrl]);

  useEffect(() => {
    setIsInstalled(window.matchMedia("(display-mode: standalone)").matches);
  }, []);

  useEffect(() => {
    dispatch(getAllUsers());
  }, [dispatch]);

  useEffect(() => {
    return () => { isMountedRef.current = false; };
  }, []);

  return (
    <div className="bg-white h-100vh">
      {checkIsInstalled()}
      <Container fluid>
        <Col lg="4">
          <div
            className="p-0 w-100"
            style={{ maxWidth: "320px", minWidth: "300px", maxHeight: "70px" }}
          >
            <img
              src={shareContact}
              alt="sharedContact"
              style={{ maxWidth: "320px", maxHeight: "180px" }}
              className="w-100 h-100 ml--3"
            />
          </div>
        </Col>
        <Row>
          <HomeLeftCol
            allUrls={allUrls}
            handleDownload={handleDownload}
            handleDownloadEcosystemPdf={handleDownloadEcosystemPdf}
            toggleFhpCoinModal={toggleFhpCoinModal}
            toggleFhpCoinVideo={toggleFhpCoinVideo}
            toggleCoinInfo={toggleCoinInfo}
            coinInfoOpen={coinInfoOpen}
          />
          <HomeCenterCol
            Modaltoggle={Modaltoggle}
            setCurrentVideoIndex={setCurrentVideoIndex}
          />
          <HomeRightCol
            isInstalled={isInstalled}
            toggleMemberShipModal={toggleMemberShipModal}
            toggleAdModal={toggleAdModal}
            appleToggle={appleToggle}
            androidToggle={androidToggle}
          />
        </Row>
      </Container>

      <HomeUserCards
        registerNoticeToggle={registerNoticeToggle}
        toggleGameDayStay={toggleGameDayStay}
        toggleFhpCoinToken={toggleFhpCoinToken}
      />

      <HomeModals
        coinInfoOpen={coinInfoOpen}
        toggleCoinInfo={toggleCoinInfo}
        appleModal={appleModal}
        appleToggle={appleToggle}
        active={active}
        setActive={setActive}
        androidModal={androidModal}
        androidToggle={androidToggle}
        registerModal={registerModal}
        registerNoticeToggle={registerNoticeToggle}
        registerNotice={registerNotice}
        setRegisterNotice={setRegisterNotice}
        history={history}
        modal={modal}
        Modaltoggle={Modaltoggle}
        videoId={videoId}
        currentVideo={currentVideo}
        handleVideoStateChange={handleVideoStateChange}
        imgModal={imgModal}
        toggleImgModal={toggleImgModal}
        showModalImg={showModalImg}
        adModalOpen={adModalOpen}
        toggleAdModal={toggleAdModal}
        isDisclaimerOpen={isDisclaimerOpen}
        disclaimerToggle={disclaimerToggle}
        membershipModal={membershipModal}
        toggleMemberShipModal={toggleMemberShipModal}
        fhpCoinModal={fhpCoinModal}
        toggleFhpCoinModal={toggleFhpCoinModal}
        schoolDiscountModal={schoolDiscountModal}
        toggleSchoolDiscount={toggleSchoolDiscount}
        vendorDiscountModal={vendorDiscountModal}
        toggleVendorDiscount={toggleVendorDiscount}
        gameDayStayModal={gameDayStayModal}
        toggleGameDayStay={toggleGameDayStay}
        tokenPoolModal={tokenPoolModal}
        toggleTokenPool={toggleTokenPool}
        fhpCoinTokenModal={fhpCoinTokenModal}
        toggleFhpCoinToken={toggleFhpCoinToken}
        fhpCoinVideoModal={fhpCoinVideoModal}
        toggleFhpCoinVideo={toggleFhpCoinVideo}
        fanSkillContest={fanSkillContest}
        toggleFanSkillContest={toggleFanSkillContest}
        sportsMemeModal={sportsMemeModal}
        toggleSportsMeme={toggleSportsMeme}
        isShow={isShow}
        toggle={toggle}
        isShow2={isShow2}
        toggle2={toggle2}
      />
    </div>
  );
}

export default Home;
